import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { SessionService } from "@shared/services/session.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuardService {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    return this.checkNotLogin();
  }

  checkNotLogin(): boolean | UrlTree {
    if (!this.sessionService.isLoggedIn) {
      return true;
    } else {
      return this.router.createUrlTree(["/home"]);
    }
  }
}

export const LoginGuard: CanActivateFn = (): boolean | UrlTree => {
  return inject(LoginGuardService).canActivate();
};
